import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "../instituteLobo/../header/style.css";
import { Header } from "../instituteLobo";
import { AdminNavbar } from "../instituteLobo";
import {
  API_BASE_URL,
  ACCESS_TOKEN_NAME,
  Image_Base_Url,
} from "../../../constants/apiConstants";
import axios from "axios";

function EditInstituteLobo() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [instituteName, setInstituteName] = useState("");
  const [existingLobo, setExistingLobo] = useState("");
  const [lobo, setLobo] = useState(null); // Store new file separately

  useEffect(() => {
    fetchLoboData();
  }, [id]);

  const fetchLoboData = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/getCollegeLogoMediaFileById/${id}`,
        {
          headers: {
            Authorization: `Bearer ${ACCESS_TOKEN_NAME()}`,
            "Content-Type": "application/json",
          },
        }
      );
      console.log("datatat", response.data);

      if (response.data.length > 0) {
        const data = response.data[0]; // Correctly accessing nested array
        setInstituteName(data.name || "");
        setExistingLobo(data.media_image_path || "");
      }
    } catch (err) {
      console.error("Error fetching data:", err);
    }
  };

  const handleFileChange = (e) => {
    setLobo(e.target.files[0]); // Store new file separately
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("name", instituteName);

    if (lobo) {
      formData.append("media_image_name", lobo); // Append new file
    } else if (existingLobo) {
      formData.append("media_image_name", existingLobo); // Keep existing image
    }

    try {
      const response = await axios.post(
        `${API_BASE_URL}/createCollegeLogoMediaFile/${id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${ACCESS_TOKEN_NAME()}`,
          },
        }
      );

      if (response.status === 200) {
        navigate("/admin/instituteLoboList");
      } else {
        console.error("Unexpected response:", response.status);
      }
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  return (
    <div>
      <Header />
      <div className="main-container">
        <AdminNavbar />
        <div className="main">
          <div className="report-container">
            <div className="report-header">
              <h1 className="recent-Articles">Edit Institute Lobo</h1>
            </div>
            <div className="report-body">
              <div className="user-form">
                <form onSubmit={handleSubmit} encType="multipart/form-data">
                  <div className="mb-3">
                    <label htmlFor="institute_name" className="form-label">
                      Institute Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="institute_name"
                      name="institute_name"
                      value={instituteName}
                      onChange={(e) => setInstituteName(e.target.value)}
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="exam_lobo" className="form-label">
                      Institute Lobo (Upload Image)
                    </label>
                    <input
                      type="file"
                      className="form-control"
                      id="exam_lobo"
                      name="exam_lobo"
                      accept="image/*"
                      onChange={handleFileChange}
                    />
                    {existingLobo && (
                      <div>
                        <p>Current Lobo:</p>
                        <img
                          src={`${Image_Base_Url}${existingLobo}`}
                          alt="Institute Lobo"
                          style={{ width: "100px", height: "100px" }}
                        />
                      </div>
                    )}
                  </div>

                  <button type="submit" className="btn btn-primary submit-btn">
                    UPDATE
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditInstituteLobo;
